import { render, staticRenderFns } from "./order-view-receiver.vue?vue&type=template&id=0b213146&scoped=true&"
import script from "./order-view-receiver.vue?vue&type=script&lang=js&"
export * from "./order-view-receiver.vue?vue&type=script&lang=js&"
import style0 from "./order-view-receiver.vue?vue&type=style&index=0&id=0b213146&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b213146",
  null
  
)

export default component.exports